import React from "react";
import { ListGroupItem } from "reactstrap";
import PropTypes from "prop-types";

class ItemDetails extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    labelClassName: PropTypes.string,
    valueClassName: PropTypes.string,
    label: PropTypes.any.isRequired,
    value: PropTypes.any,
    children: PropTypes.any
  };

  static defaultProps = {
    className: "",
    labelClassName: "",
    valueClassName: "",
    children: null
  };

  render() {
    const {
      className,
      labelClassName,
      valueClassName,
      label,
      children,
      value
    } = this.props;
    return (
      <ListGroupItem
        tag="div"
        className={`list-group__item ${className}`.trim()}
      >
        <div className={`list-group__label ${labelClassName}`.trim()}>
          {label}
        </div>
        {children ? (
          <div className="list-group__value">{children}</div>
        ) : (
          <span className={`list-group__value ${valueClassName}`.trim()}>
            {value}
          </span>
        )}
      </ListGroupItem>
    );
  }
}

export default ItemDetails;
